import { render } from "./ManageAccount.vue?vue&type=template&id=03ff3f66&scoped=true&ts=true"
import script from "./ManageAccount.vue?vue&type=script&lang=ts"
export * from "./ManageAccount.vue?vue&type=script&lang=ts"

import "./ManageAccount.vue?vue&type=style&index=0&id=03ff3f66&lang=scss&scoped=true"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ff3f66"]])

export default __exports__